import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { ContributionTier } from './contributionTier.ts';
import { Item } from './item.ts';

export class ContributionType extends Model<Schemas['contributionTypes'], Models> {
    public tiersForContentType(contentType: string): ContributionTier[] {
        return this.tiers?.filter((t) => !t.contentType || t.contentType === contentType) || [];
    }

    public tiersForItem(item: Item): ContributionTier[] {
        return this.tiersForContentType(item.contentType);
    }
}
